import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getCatalogoByFilters, getCatalogoParams } from "./Catalogo.service"

export function useCatalogoByFilters(queryParams?: getCatalogoParams) {
  const queryClient = useQueryClient()
  const { data: catalogoByFilters, isLoading: catalogoByFiltersLoading } =
    useQuery({
      queryKey: ["getCatalogoByFilters", queryParams],
      queryFn: () => getCatalogoByFilters(queryParams),
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 20,
    })
  const categoriaCatalogoByFiltersInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["getCatalogoByFilters"] })

  return {
    catalogoByFilters,
    catalogoByFiltersLoading,
    categoriaCatalogoByFiltersInvalidation,
  }
}
